import { gql } from '@apollo/client';

export const RESOURCE_DAY_BILLING_FIELDS = gql`
    fragment ResourceDayBillingFields on resource_day_billing_view {
        resource_id
        delivery_day
        billable_orders
        uninvoiced_orders
        invoiced_orders
        draft_orders
        unpaid_orders
        approved_orders
        processing_orders
        paid_orders
        cancelled_orders
    }
`;

// Past days only — the calendar shows billing status behind, never ahead.
export const QUERY_RESOURCE_DAY_BILLING = gql`
    ${RESOURCE_DAY_BILLING_FIELDS}

    query ResourceDayBilling($resource_ids: [uuid!]!, $start: date!, $end: date!) {
        resource_day_billing_view(
            where: {
                resource_id: { _in: $resource_ids }
                delivery_day: { _gte: $start, _lte: $end }
            }
        ) {
            ...ResourceDayBillingFields
        }
    }
`;
